/**
 * Reeora Product Page Custom Enhancements v3
 * Title selector fixed: Ritual theme renders title as <p> inside .product-information
 */
(function () {
  'use strict';

  // Only run on product pages
  function isProductPage() {
    if (window.location.pathname.includes('/products/')) return true;
    var main = document.querySelector('main[data-template]');
    if (main && main.dataset.template && main.dataset.template.includes('product')) return true;
    if (document.body.dataset.template && document.body.dataset.template.includes('product')) return true;
    if (document.querySelector('.product-information')) return true;
    return false;
  }

  if (!isProductPage()) return;

  // Inject CSS
  var css = [
    '/* 1. Hide search icon on product pages */',
    '.product-information ~ * header-search { display: none !important; }',
    'body.template-product header-search { display: none !important; }',
    '.reeora-hide { display: none !important; }',

    '/* 2. Title */',
    '.reeora-product-name {',
    '  font-family: var(--font-heading-family, "Playfair Display", serif) !important;',
    '  font-size: clamp(1.8rem, 4vw, 3rem) !important;',
    '  font-weight: 700 !important;',
    '  line-height: 1.15 !important;',
    '  margin: 0 0 0.3em !important;',
    '  text-transform: none !important;',
    '  letter-spacing: -0.01em !important;',
    '  display: block !important;',
    '}',
    '.reeora-product-subtitle {',
    '  font-size: 0.72rem !important;',
    '  font-weight: 500 !important;',
    '  letter-spacing: 0.12em !important;',
    '  text-transform: uppercase !important;',
    '  color: #999 !important;',
    '  margin: 0 0 1em !important;',
    '  display: block !important;',
    '}',
    '.reeora-title-src { display: none !important; }',

    '/* 3. Price */',
    '.price__regular .price-item--regular,',
    '.price__sale .price-item--sale {',
    '  font-size: 1.2rem !important;',
    '  font-weight: 600 !important;',
    '}',

    '/* 4. WhatsApp button */',
    '.reeora-whatsapp-btn {',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  gap: 8px !important;',
    '  width: 100% !important;',
    '  padding: 13px 20px !important;',
    '  margin-top: 10px !important;',
    // ⭐ SOLID WHATSAPP GREEN, NOT AN OUTLINE. #25D366 is WhatsApp's own brand green
    // and the filled pill with a white glyph is the shape people already recognise from
    // every other site. Outlined-with-green-text read as "a button about WhatsApp";
    // filled reads as WhatsApp.
    '  border: 1.5px solid #25D366 !important;',
    '  border-radius: 4px !important;',
    '  background: #25D366 !important;',
    '  color: #ffffff !important;',
    '  font-size: 0.9rem !important;',
    '  font-weight: 600 !important;',
    '  letter-spacing: 0.04em !important;',
    '  cursor: pointer !important;',
    '  text-decoration: none !important;',
    '  box-sizing: border-box !important;',
    '  transition: background 0.18s, color 0.18s !important;',
    '}',
    // Hover darkens rather than fills, since the resting state is already filled.
    '.reeora-whatsapp-btn:hover { background: #128c7e !important; border-color: #128c7e !important; color: #fff !important; }',

    '/* 5. Accordion */',
    '.reeora-accordion { border-top: 1px solid #e5e5e5; margin: 1.2em 0; }',
    '.reeora-accordion-item { border-bottom: 1px solid #e5e5e5; }',
    '.reeora-accordion-trigger {',
    '  display: flex; align-items: center; justify-content: space-between;',
    '  width: 100%; padding: 1em 0; background: none; border: none; cursor: pointer;',
    '  font-size: 0.85rem; font-weight: 600; letter-spacing: 0.06em;',
    '  text-transform: uppercase; text-align: left; color: inherit;',
    '}',
    '.reeora-accordion-icon { width: 16px; height: 16px; transition: transform 0.25s; flex-shrink: 0; }',
    '.reeora-accordion-trigger[aria-expanded="true"] .reeora-accordion-icon { transform: rotate(45deg); }',
    '.reeora-accordion-body { display: none; padding: 0 0 1em; font-size: 0.875rem; line-height: 1.65; color: #555; }',
    '.reeora-accordion-body.is-open { display: block; }',
    '.reeora-accordion-body ul { margin: 0.4em 0 0; padding-left: 1.2em; }',
    '.reeora-accordion-body li { margin-bottom: 0.3em; }',

    '/* 6. Hide non-wig related cards */',
    '.reeora-hidden-card { display: none !important; }'
  ].join('\n');

  var styleEl = document.createElement('style');
  styleEl.id = 'reeora-custom-styles';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ── 1. Hide search ──────────────────────────────────────────────────────────
  function hideSearch() {
    document.querySelectorAll('header-search').forEach(function(el) {
      el.classList.add('reeora-hide');
    });
  }

  // ── 2. Restructure title ────────────────────────────────────────────────────
  function restructureTitle() {
    // The Ritual theme renders the product title as a <p> inside .product-information
    var titleEl = null;

    // Strategy 1: find any <p> or heading inside product-information with a pipe
    var container = document.querySelector('.product-information');
    if (container) {
      var candidates = container.querySelectorAll('p, h1, h2, h3');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.textContent.includes('|') && !el.dataset.reeoraProcessed) {
          titleEl = el;
          break;
        }
      }
    }

    // Strategy 2: broader fallback
    if (!titleEl) {
      var all = document.querySelectorAll('p, h1, h2');
      for (var j = 0; j < all.length; j++) {
        if (all[j].textContent.includes('|') && !all[j].dataset.reeoraProcessed
            && !all[j].closest('.resource-card, .card, footer, nav')) {
          titleEl = all[j];
          break;
        }
      }
    }

    if (!titleEl) return;

    var fullTitle = titleEl.textContent.trim();
    if (!fullTitle.includes('|')) return;
    titleEl.dataset.reeoraProcessed = '1';

    var parts = fullTitle.split('|').map(function(s) { return s.trim(); });
    var name = parts[0];
    var subtitleParts = parts.slice(1);

    var nameEl = document.createElement('span');
    nameEl.className = 'reeora-product-name';
    nameEl.textContent = name;

    var subtitleEl = document.createElement('span');
    subtitleEl.className = 'reeora-product-subtitle';
    subtitleEl.textContent = subtitleParts.join(' · ');

    // Insert before the original element (keep same DOM context)
    titleEl.classList.add('reeora-title-src');
    titleEl.parentNode.insertBefore(nameEl, titleEl);
    titleEl.parentNode.insertBefore(subtitleEl, titleEl);
  }

  // ── 4. WhatsApp button ──────────────────────────────────────────────────────
  function injectWhatsApp() {
    if (document.querySelector('.reeora-whatsapp-btn')) return;

    var WHATSAPP = '919619246618';
    var productName = document.querySelector('.reeora-product-name')
      ? document.querySelector('.reeora-product-name').textContent.trim()
      : document.title.split('|')[0].trim();
    var msg = 'Hi! I am interested in ' + productName + ' - ' + window.location.href;
    var url = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(msg);

    var btn = document.createElement('a');
    btn.href = url;
    btn.target = '_blank';
    btn.rel = 'noopener noreferrer';
    btn.className = 'reeora-whatsapp-btn';
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg> Chat on WhatsApp';

    // Find the cart form and insert the button right after it
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.insertAdjacentElement('afterend', btn);
    } else {
      // Fallback: after sold-out or add-to-cart button
      var atcBtn = document.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
      if (atcBtn) {
        var wrap = atcBtn.closest('div, section, form') || atcBtn.parentElement;
        wrap.insertAdjacentElement('afterend', btn);
      }
    }
  }

  // ── 5. Accordion ────────────────────────────────────────────────────────────
  function buildAccordion() {
    var descEl = document.querySelector(
      '[data-block-type="description"] .rte, [data-block-type="product-description"] .rte, ' +
      '.product__description .rte, .product__description'
    );
    if (!descEl || descEl.dataset.reeoraAccordion) return;
    var headings = descEl.querySelectorAll('h2, h3, h4');
    if (headings.length < 2) return;
    descEl.dataset.reeoraAccordion = '1';

    var accordion = document.createElement('div');
    accordion.className = 'reeora-accordion';
    var currentBody = null;

    Array.from(descEl.childNodes).forEach(function(node) {
      var tag = node.nodeName.toLowerCase();
      if (tag === 'h2' || tag === 'h3' || tag === 'h4') {
        var item = document.createElement('div');
        item.className = 'reeora-accordion-item';
        var trigger = document.createElement('button');
        trigger.className = 'reeora-accordion-trigger';
        trigger.type = 'button';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.innerHTML = '<span>' + node.textContent.trim() + '</span>' +
          '<svg class="reeora-accordion-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
        trigger.addEventListener('click', function() {
          var open = this.getAttribute('aria-expanded') === 'true';
          this.setAttribute('aria-expanded', String(!open));
          this.nextElementSibling.classList.toggle('is-open', !open);
        });
        currentBody = document.createElement('div');
        currentBody.className = 'reeora-accordion-body';
        item.appendChild(trigger);
        item.appendChild(currentBody);
        accordion.appendChild(item);
      } else if (currentBody && (node.nodeName !== '#text' || node.textContent.trim())) {
        currentBody.appendChild(node.cloneNode(true));
      }
    });

    if (accordion.children.length > 0) {
      descEl.replaceWith(accordion);
      var first = accordion.querySelector('.reeora-accordion-trigger');
      var firstBody = accordion.querySelector('.reeora-accordion-body');
      if (first && firstBody) { first.setAttribute('aria-expanded', 'true'); firstBody.classList.add('is-open'); }
    }
  }

  // ── 6. Filter related products ──────────────────────────────────────────────
  function filterRelated() {
    var wigKw = ['wig', 'lace', 'closure', 'frontal', 'topper', 'extension', 'silk base', 'crown'];
    var exKw = ['cap', 'brush', 'comb', 'spray', 'glue', 'accessory', 'accessories', 'stand', 'mannequin'];
    var sec = document.querySelector('[data-section-type*="related"], [data-section-type*="recommendation"], .product-recommendations');
    if (!sec) return;
    sec.querySelectorAll('[data-product-id], .card, .product-card').forEach(function(card) {
      var t = card.textContent.toLowerCase();
      var isWig = wigKw.some(function(k) { return t.includes(k); });
      var isEx = exKw.some(function(k) { return t.includes(k); }) && !isWig;
      if (isEx) card.classList.add('reeora-hidden-card');
    });
  }

  function runAll() {
    hideSearch();
    restructureTitle();
    buildAccordion();
    injectWhatsApp();
    filterRelated();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // Delayed retries for dynamically rendered content
  setTimeout(runAll, 600);
  setTimeout(runAll, 1800);

  document.addEventListener('variant:changed', function() { setTimeout(injectWhatsApp, 300); });
  document.addEventListener('page:load', function() { if (isProductPage()) { setTimeout(runAll, 300); } });
})();
